<template>
	<div class="container g-flex g-row-center">
		<div class="g-flex g-row-between total-width g-full-height">
			<!-- logo -->
			<img src="@/assets/home/logo2.png" class="logo" alt="">
			<!--   menu   -->
			<div class="menu-list g-m-l-50 g-flex g-full-height">
				<div class="menu-item g-flex g-row-center g-font-16 white-text"
					:class="{'active-text':index === menuIndex}" v-for="(item,index) in menuList " :key="index"
					@click="menuChange(item,index)">
					{{item.name}}
				</div>
			</div>
			<div class="g-flex-right">
				<!--   登录   -->
				<div class="g-flex g-row-between" v-if="!getLoginState">
					<el-button class="btn g-font-14" @click="goReg">我要入驻</el-button>
					<el-button plain class="btn g-font-14" @click="goPage('login',1)">登录</el-button>
					<!--<el-button plain class="btn g-font-14" @click="goPage('login',2)">注册</el-button>-->
				</div>
				<!--       -->
				<div class="g-flex g-row-between" v-else>
					<p class="g-font-14 find-color g-m-r-20 pointer" @click="goReg">我要入驻</p>
					<p class="g-font-14 find-color g-m-r-20 g-rela pointer" @click="goMineNews">
						消息
						<span class="news-num" v-if="!!msgNum&&msgNum>0"></span>
					</p>

					<el-dropdown @command="dropMenuClick">
						<img :src="getUserAvatar" class="avatar g-m-l-20" alt="">
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="item.value" v-for="(item,index) in dropMenuList" :key="index">
								{{item.name}}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<!--   用户头像 下拉菜单   -->
					<!-- <el-dropdown @command="dropMenuClick" v-else>
						<img :src="getUserAvatar" class="avatar g-m-l-20" alt="">
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="item.value" v-for="(item,index) in dropMenuListB" :key="index">
								{{item.name}}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown> -->

				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import {
		messageList,
		messageCount
	} from "@/api/api.js"
	import {
		delCookie
	} from '@/utils/common.js'
	import Cookies from 'js-cookie';
	export default {
		name: "head-bar",
		data() {
			return {
				menuList: [{
						name: '首页',
						value: 'home'
					},
					{
						name: '找工作',
						value: 'find-job',
						skip: false
					},
					// {
					// 	name: '找人才',
					// 	value: 'find-careers',
					// 	skip: false
					// },
					{
						name: '培训课程',
						value: 'course-list'
					},
					{
						name: '考核认证',
						value: 'examination'
					},
					{
						name: '关于我们',
						value: 'about-us'
					}
				], //菜单列表
				dropMenuList: [{
						name: '个人中心',
						value: 1
					},
					{
						name: '我的消息',
						value: 2
					},
					{
						name: '我的简历',
						value: 3
					},
					{
						name: '投递记录',
						value: 4
					},
					{
						name: '我的课程',
						value: 5
					},
					{
						name: '我的考试',
						value: 6
					},
					{
						name: '我的证书',
						value: 7
					},

					{
						name: '我的订单',
						value: 8
					},
					{
						name: '退出登录',
						value: 9
					}
				], //下拉菜单列表
				dropMenuListB: [{
						name: '管理后台',
						value: 11
					},
					{
						name: '退出登录',
						value: 9
					}
				], //下拉菜单列表
				menuIndex: 0, //菜单下标
				isLogin: false, //是否登录的状态，目前是模拟从store中获取，后期请改成从接口获取判断是否登录
				// msgNum: 0
			}
		},
		computed: {
			getLoginState() {
				return this.$store.state.isLogin
			},
			getUserRole() {
				return this.$store.state.userInfo.role_name
			},
			getUserAvatar() {
				return this.$store.state.userInfo.avatar ? this.$store.state.userInfo.avatar : this.$store.state
					.defaultAvatar
			},
			isClinic() {
				return this.$store.state.isLogin && (this.$store.state.userInfo.clinic_id != '' && this.$store.state
					.userInfo.clinic_id != -1)
			},
			isCustomer() {
				return this.$store.state.isLogin && (this.$store.state.userInfo.clinic_id == '' || this.$store.state
					.userInfo.clinic_id == -1)
			},
			hideMenue() {
				return index => {
					if(index==1){
						return this.$store.state.isLogin && (this.$store.state.userInfo.clinic_id != '' && this.$store.state.userInfo.clinic_id != -1)
					}else if(index==2){
						return  !this.$store.state.isLogin||this.$store.state.isLogin && (this.$store.state.userInfo.clinic_id == '' || this.$store.state.userInfo.clinic_id == -1)
					}else{
						return false
					}
				};

			},
			msgNum(){
				return this.$store.state.totalNewsNum;
			}
		},
		created() {

			this.initMessageNum();
		},
		methods: {
			initMessageNum() {
				// messageList({
				// 	current: 1,
				// 	size: 10
				// }).then(res => {
				// 	this.msgNum = res.records.reduce((total,curVal)=>{
				// 		if(curVal.status==0){
				// 			return total+1;
				// 		} else {
				// 			return total;
				// 		}
				// 	},0)
				// 	// this.msgNum = res.total > 99 ? '99+' : res.total;
				// })
				this.$store.dispatch('getTotalNewsNum');
			},
			// 导航菜单点击切换事件
			menuChange(item, index) {
				console.log("this.menuIndex", index)
				if (this.menuIndex !== index) {

					this.menuIndex = index
					this.$router.push({
						name: item.value
					})
				}
			},
			// 下拉菜单点击事件
			dropMenuClick(e) {
				let name = this.$route.name
				// 其他页面跳转
				if (name !== 'mine') {
					if (e * 1 < 9) {
						this.$router.push({
							name: 'mine',
							query: {
								menuIndex: e - 1
							}
						})
						//  退出登录
					} else {
						if (e * 1 == 9) {
							this.$store.commit('$uStore', {
								name: 'isLogin',
								value: false
							})
							this.$store.commit('$uStore', {
								name: 'accessToken',
								value: ''
							})
							this.$store.commit('$uStore', {
								name: 'refreshToken',
								value: ''
							})
							this.$store.commit('$uStore', {
								name: 'userInfo',
								value: {}
							})
							this.$store.commit('setLogin', false)
							localStorage.clear()
							this.$router.replace({
								name: 'login'
							})
						}
						if (e * 1 == 11) {
							this.goReg()
						}
					}
				} else {
					// 个人中心点下拉菜单

					if (e * 1 == 9) {
						// this.$store.commit('$uStore',{name:'isLogin',value:false})
						// this.$store.commit('$uStore',{name:'accessToken',value:''})
						// this.$store.commit('$uStore',{name:'refreshToken',value:''})
						// this.$store.commit('$uStore',{name:'userInfo',value:{}})
						// delCookie()
						// this.$store.commit('setLogin', false)
						//localStorage.removeItem('accessToken')
						this.$store.commit('$uStore', {
							name: 'isLogin',
							value: false
						})
						this.$store.commit('$uStore', {
							name: 'accessToken',
							value: ''
						})
						this.$store.commit('$uStore', {
							name: 'refreshToken',
							value: ''
						})
						this.$store.commit('$uStore', {
							name: 'userInfo',
							value: {}
						})
						this.$store.commit('setLogin', false)
						localStorage.clear()
						this.$router.replace({
							name: 'login'
						})
					} else {
						this.$emit('mineMenuChange', e - 1)
					}
				}
			},
			// 其他页面跳转
			goPage(name, val) {
				this.$router.push({
					name: name,
					query: {
						tabIndex: val
					}
				})
			},
			// 跳转后台注册
			goReg() {
				window.location.href = 'https://admin.yzhkq.com/'
			},
			// 跳转我的消息
			goMineNews() {
				this.$router.push({
					name: 'mine',
					query: {
						menuIndex: '1'
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		height: 55px;
		background: #407AFF;
		position: sticky;
		top: 0;
		z-index: 99;
	}

	.logo {
		width: 100px;
		height: 40px;
	}

	.menu-list {
		align-items: stretch;

		.menu-item {
			width: 125px;
			height: 100%;
			cursor: pointer;

			&:hover {
				background: #1f63ff;
				transition: all ease-in 0.2s;
			}
		}

		.active-text {
			background: #1f63ff;
			transition: all ease-in 0.2s;
		}
	}

	.find-color {
		color: #BFD3FF;
	}

	.btn {
		border: 1px solid #8bafff;
		border-radius: 20px;
		padding: 4px 16px;
		background: #407aff;
		color: #fff;
	}

	.news-num {
		position: absolute;
		// top: -18px;
		top: 0;
		right: -20px;
		width: 10px;
		height: 10px;
		// padding: 2px 4px;
		// border-radius: 10px;
		border-radius: 50%;
		background: #ff5a5a;
		// color: #fff;
		// font-size: 10px;
	}

	.avatar {
		width: 35px;
		height: 35px;
		border-radius: 50%;
		box-shadow: 0 0 10px 0 rgba(40, 48, 137, 0.50);
	}
</style>
